import { activeTenantNamespacedKey } from '@auw/tenant';

export interface AuthSessionInvalidatedDetail {
  reason?: string;
  redirectTo?: string;
}

/* Tenant-scoped CustomEvent name: multiple tenants sharing a dev
 * origin must not cross-trigger each other's auth-reset handlers.
 *
 * Resolved lazily so this module's evaluation does not require the
 * host's tenant manifest to be registered yet. Cached after first
 * read because tenant identity is fixed for the page lifetime. */
let _authSessionInvalidatedEvent: string | null = null;
function getAuthSessionInvalidatedEvent(): string {
  if (_authSessionInvalidatedEvent === null) {
    _authSessionInvalidatedEvent = activeTenantNamespacedKey('auth-session-invalidated');
  }
  return _authSessionInvalidatedEvent;
}

export function dispatchAuthSessionInvalidated(
  detail: AuthSessionInvalidatedDetail = {},
): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<AuthSessionInvalidatedDetail>(
    getAuthSessionInvalidatedEvent(),
    { detail },
  ));
}

export function subscribeAuthSessionInvalidated(
  handler: (detail: AuthSessionInvalidatedDetail) => void,
): () => void {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const listener = (event: Event) => {
    const customEvent = event as CustomEvent<AuthSessionInvalidatedDetail>;
    handler(customEvent.detail ?? {});
  };

  const eventName = getAuthSessionInvalidatedEvent();
  window.addEventListener(eventName, listener);
  return () => {
    window.removeEventListener(eventName, listener);
  };
}
